import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TravelItem } from '../../../api/models';

@Component({
  selector: 'app-modal-share-on-socials',
  templateUrl: './modal-share-on-socials.component.html',
  styleUrl: './modal-share-on-socials.component.scss'
})
export class ModalShareOnSocialsComponent {

  copied = false;
  url?: string;
  travel?: TravelItem;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private messageService: MessageService,
    private meta: Meta
  ){ 
    this.url = config.data.url;
    this.travel = config.data.travel;
  }

  ngOnInit(){
    // this.meta.updateTag({property: 'og:title', content: `${this.travel!.name}`});
    // this.meta.updateTag({property: 'og:image', content: `${this.travel!.medias[0].media.path}`});
    // this.meta.updateTag({property: 'og:url', content: `${this.url}`})
  }

  shareOn(platform: string) {
    const url = this.url;
    let shareUrl = '';
    switch (platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=Guarda questo viaggio su Socialtravels!`;
        break;
      case 'whatsapp':
        shareUrl = `https://wa.me/?text=${encodeURIComponent('Guarda questo viaggio:')} ${url}`;
        break;
    }
  
    window.open(shareUrl, '_blank');
  }

  shareViaEmail() {
    const subject = encodeURIComponent('Guarda questo viaggio su Socialtravels!');
    const body = encodeURIComponent(`Dai un'occhiata a questo viaggio su Socialtravels: ${this.url}`);
    const mailtoLink = `mailto:?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;
  }

  copyLink() {
    navigator.clipboard.writeText(this.url!).then(() => {
      this.copied = true;
      setTimeout(() => this.copied = false, 2000);
      this.messageService.add({
        severity: 'success',
        summary: 'Condividi viaggio',
        detail: "Link copiato negli appunti!",
      });
    }).catch(err => {
      console.error('Errore durante la copia:', err);
    });
    //https://www.google.com/search?client=firefox-b-d&q=js+copy+to+clipboard
  }

  // printPage() {
  //   this.ref.close({ readyForPrinting: true });
  // }

}
